export default __webpack_public_path__ + "static/media/Sielanka-wesele2.8560a39f.JPG";